<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">

body,
html,
#app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  list-style:none;
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  ::v-deep .tooltip {
  width: 200px;
}

.el-button--small{
  padding:5px 10px;
}
.el-button--mini{
  padding:5px 10px;
}
.el-button{
  padding:7px 10px;
}
.el-input__inner{
  height:38px
}

}
</style>